import React, { MouseEvent } from "react";
import { AxiosResponse, AxiosError } from "axios";
import DataGrid, {
    Pager,
    Paging,
    Export,
    FilterRow,
    Column,
    SearchPanel,
    Format,
    Selection,
} from "devextreme-react/data-grid";
import { LoadIndicator } from "devextreme-react";
import gridUtils, { currencyTypes, currencyTypeToSymbolMatrix } from "../grid/GridUtilities";
import PaymentService, { paymentGridTypes, viewDetailsGridRowItem } from "../../services/PaymentService";
import { DataGridOnSelectionChanged } from "../../types/DevExtremeTypes";
import UserService, { RoleGroupNames } from "../../services/UserService";
import ManageDocumentsGridService from "../../services/ManageDocumentsGridService";
import InvoiceAmountCell from "../../components/Payments/ProviderPayment/InvoiceAmountCellComponent";
import paymentActionCell from "../Payments/PaymentActionCellComponent";
import sharedUtils from "../grid/sharedUtilities";
import { onExportingEvent } from "../../types/DevExtremeTypes";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";
import AllUserGridService from "../grid/AllUserGridService";
import { Link } from "react-router-dom";
import { Popup, ScrollView } from "devextreme-react";
import ClientInformationMainContent from "../ClientInformation/ClientInformationMainContent";
interface PaymentsGridProviderWithDetailsProps {
    setPaymentIdOnParent: (paymentId: string) => void;
    gridType: string;
    paymentsRefresh: boolean;
    location: any;
    history: any;
    providerId?: string;
    startDate?: string;
    endDate?: string;
    serviceTypeId?: string;
    status?: [];
    isFasterPayments?: boolean;
    paymentCycleId?: string;
}
interface PaymentsGridProviderWithDetailsState {
    gridDataSource: viewDetailsGridRowItem[];
    showProgressIndicator: boolean;
    clientId: string;
    venueId: string;
    venuePopupVisible: boolean;
}

class PaymentsGridProviderWithDetails extends React.Component<PaymentsGridProviderWithDetailsProps> {
    state: PaymentsGridProviderWithDetailsState;
    //Initialize the service to fetch the data.
    Service: PaymentService;
    sharedUtils: sharedUtils;
    manageGridService: ManageDocumentsGridService;
    //Reuse the Grid utils component to format the cells.
    gridUtils: gridUtils;
    userHasAccess: boolean;
    //_isMounted:boolean;

    constructor(props: PaymentsGridProviderWithDetailsProps) {
        super(props);
        // Initialize state and services/utils
        this.Service = new PaymentService();
        this.sharedUtils = new sharedUtils();
        this.gridUtils = new gridUtils();
        this.manageGridService = new ManageDocumentsGridService();
        this.userHasAccess =
            UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager) ||
            UserService.isUserInGroup(RoleGroupNames.EventUKRelationshipManager) ||
            UserService.isUserInGroup(RoleGroupNames.ProviderScheduler) ||
            UserService.isUserInGroup(RoleGroupNames.ProviderSiteManager) ||
            UserService.isUserInGroup(RoleGroupNames.Artist);
        this.state = {
            gridDataSource: [],
            showProgressIndicator: false,
            clientId: "",
            venueId: "",
            venuePopupVisible: false,
        };
        this.updateGridDataSource = this.updateGridDataSource.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleError = this.handleError.bind(this);
    }

    componentDidMount() {
        if (
            this.props.location?.state?.navigateFrom &&
            this.props.location?.state?.navigateFrom !== "PaymentRequestFailed" &&
            this.props.location?.state?.navigateFrom !== "PaymentWithFasterPayments"
        ) {
            this.updateGridDataSource();
        }
        if (this.state.gridDataSource.length === 0) {
            this.updateGridDataSource();
        }
    }

    componentDidUpdate(prevprops: PaymentsGridProviderWithDetailsProps) {
        if (
            this.props.paymentsRefresh != prevprops.paymentsRefresh ||
            this.props.serviceTypeId != prevprops.serviceTypeId ||
            this.props.providerId != prevprops.providerId ||
            this.props.startDate != prevprops.startDate ||
            this.props.endDate != prevprops.endDate ||
            this.props.status != prevprops.status ||
            this.props.isFasterPayments != prevprops.isFasterPayments ||
            this.props.location.state?.navigateFrom != prevprops.location.state?.navigateFrom
        ) {
            this.updateGridDataSource();
        }
    }

    updateGridDataSource() {
        if (this.userHasAccess) {
            this.setState({
                showProgressIndicator: true,
            });
            let startDate: string = "";
            let endDate: string = "";
            startDate = this.props.startDate ? this.props.startDate : "";
            endDate = this.props.endDate ? this.props.endDate : "";
            if (this.props.location?.state?.navigateFrom == "PaymentRequestFailed") {
                this.setState({
                    allowSelection: "none",
                });
                this.Service.generatePaymentsForProviderWithBillableItem(
                    this.props.paymentCycleId,
                    this.props.providerId,
                    this.props.serviceTypeId,
                    startDate,
                    endDate,
                    this.props.status,
                    this.props.isFasterPayments,
                    "PaymentRequestFailed"
                )
                    .then(this.handleSuccess)
                    .catch(this.handleError);
            } else if (this.props.location.state?.navigateFrom == "PaymentWithFasterPayments") {
                this.setState({
                    allowSelection: "none",
                });
                this.Service.generatePaymentsForProviderWithBillableItem(
                    this.props.paymentCycleId,
                    this.props.providerId,
                    this.props.serviceTypeId,
                    startDate,
                    endDate,
                    this.props.status,
                    this.props.isFasterPayments,
                    "PaymentWithFasterPayments"
                )
                    .then(this.handleSuccess)
                    .catch(this.handleError);
            } else {
                var typeOfGridDataSource = this.props.gridType;
                switch (typeOfGridDataSource) {
                    case paymentGridTypes.providerPayment:
                        this.setState({
                            allowSelection: "none",
                        });
                        this.Service.generatePaymentsForProviderWithBillableItem(
                            this.props.paymentCycleId,
                            this.props.providerId,
                            this.props.serviceTypeId,
                            startDate,
                            endDate,
                            this.props.status,
                            this.props.isFasterPayments
                        )
                            .then(this.handleSuccess)
                            .catch(this.handleError);
                        break;
                    case paymentGridTypes.artistPayment:
                        this.setState({
                            allowSelection: "single",
                        });
                        this.Service.generatePaymentsForProviderWithBillableItem(
                            this.props.paymentCycleId,
                            this.props.providerId,
                            this.props.serviceTypeId,
                            startDate,
                            endDate,
                            this.props.status,
                            this.props.isFasterPayments
                        )
                            .then(this.handleSuccess)
                            .catch(this.handleError);
                        break;
                }
            }
        }
    }

    handleSuccess(response: AxiosResponse<any>) {
        let updatedGridValue = response.data.data.map((item: any) => {
            return {
                ...item,
                dateFrom: this.formatToDDMMYYYY(item.dateFrom),
                billableStartTime: this.formatToHHMM(item.billableStartTime),
                billableFinishTime: this.formatToHHMM(item.billableFinishTime),
            };
        });
        this.setState({
            gridDataSource: updatedGridValue,
            showProgressIndicator: false,
        });
    }

    handleError(error: AxiosError<any>) {
        // Redirect back to home page on a 401 unauth error
        if (error.response != null && error.response.status === 401) {
            this.props.history.push({
                pathname: "/",
            });
        } else {
            this.setState({
                showProgressIndicator: false,
            });
            var respMessage: string = "Payments grid provider failed with response: " + JSON.stringify(error);

            if (!this.Service.traceAsErrorToAppInsights(respMessage)) {
                // AppInsights is not available
                console.error(respMessage);
            }
        }
    }

    // Fire parent component's callback with data from grid
    onSelectionChanged = (event: DataGridOnSelectionChanged) => {
        // Capture the PaymentId of the clicked row.
        var paymentId: string = "";
        if (event.selectedRowsData && event.selectedRowsData.length > 0) {
            paymentId = event.selectedRowsData[0].paymentId;
        }
        this.props.setPaymentIdOnParent(paymentId);
    };

    onExporting = (e: onExportingEvent) => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            customizeCell: ({ gridCell, excelCell }) => {
                const col = gridCell?.column;
                if (gridCell?.rowType === "header" && col?.name === "fasterPayOriginalAmountTotal") {
                    excelCell.value = "PAY AMOUNTS (FP CALC)";
                    return;
                }
                if (gridCell?.rowType === "header" && col?.dataField === "fasterPayOriginalAmount" && !col.name) {
                    excelCell.value = "ORIGINAL FEE";
                    return;
                }
                if (col?.name === "fasterPayOriginalAmountTotal") {
                    const row = gridCell?.data;
                    const currencySymbol = currencyTypeToSymbolMatrix[row.currency];

                    const subAmount = this.gridUtils.convertDecimalAsStringToCurrency(row.subAmount, currencySymbol);
                    const originalAmount = this.gridUtils.convertDecimalAsStringToCurrency(
                        row.fasterPayOriginalAmount,
                        currencySymbol
                    );
                    const fee = this.gridUtils.convertDecimalAsStringToCurrency(row.fasterPayFee, currencySymbol);

                    const displayValue =
                        row.fasterPay === true && fee !== "£0" && row.originatingBillableItemId !== ""
                            ? `${subAmount} (${originalAmount} - ${fee})`
                            : `${subAmount}`;

                    excelCell.value = displayValue;
                    return;
                }
                if (col?.caption === "ORIGINAL FEE" && gridCell?.rowType === "data") {
                    const row = gridCell?.data;
                    const currencySymbol = currencyTypeToSymbolMatrix[row.currency];

                    const originalAmount = this.gridUtils.convertDecimalAsStringToCurrency(
                        row.fasterPayOriginalAmount,
                        currencySymbol
                    );
                    excelCell.value = originalAmount;
                    return;
                }
                if (col?.caption === "FASTER PAY FEE" && gridCell?.rowType === "data") {
                    const row = gridCell?.data;
                    const currencySymbol = currencyTypeToSymbolMatrix[row.currency];

                    const originalAmount = this.gridUtils.convertDecimalAsStringToCurrency(
                        row.fasterPayFee,
                        currencyTypeToSymbolMatrix[currencySymbol]
                    );
                    excelCell.value = originalAmount;
                    return;
                }
            },
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DataGrid.xlsx");
            });
        });
        e.cancel = true;
    };

    calculatePayAmounts = (cellInfo: any) => {
        let subAmount = this.gridUtils.convertDecimalAsStringToCurrency(
            cellInfo.data.subAmount,
            currencyTypeToSymbolMatrix[cellInfo.data.currency]
        );
        let fasterPayOriginalAmount = this.gridUtils.convertDecimalAsStringToCurrency(
            cellInfo.data.fasterPayOriginalAmount,
            currencyTypeToSymbolMatrix[cellInfo.data.currency]
        );
        let fasterPayFee = this.gridUtils.convertDecimalAsStringToCurrency(
            cellInfo.data.fasterPayFee,
            currencyTypeToSymbolMatrix[cellInfo.data.currency]
        );
        return (
            <div className="fa-file">
                {cellInfo.data.fasterPay == true &&
                fasterPayFee !== "£0" &&
                cellInfo.data.originatingBillableItemId != "" ? (
                    <b>
                        {subAmount} ({fasterPayOriginalAmount} - {fasterPayFee})
                    </b>
                ) : (
                    <b>{subAmount}</b>
                )}
            </div>
        );
    };

    calculatefasterPayOriginalAmount = (cellInfo: any) => {
        let fasterPayOriginalAmount = this.gridUtils.convertDecimalAsStringToCurrency(
            cellInfo.data.fasterPayOriginalAmount,
            currencyTypeToSymbolMatrix[cellInfo.data.currency]
        );

        return <div>{fasterPayOriginalAmount}</div>;
    };

    calculatefasterPayFee = (cellInfo: any) => {
        let fasterPayFee = this.gridUtils.convertDecimalAsStringToCurrency(
            cellInfo.data.fasterPayFee,
            currencyTypeToSymbolMatrix[cellInfo.data.currency]
        );
        return <div>{fasterPayFee}</div>;
    };

    fasterPayCellDisplayContent = (cellInfo: any) => {
        let fasterPayVal = cellInfo.data.data.fasterPay;
        let valToShow: string = "";
        if (fasterPayVal) {
            valToShow = "Yes";
        } else {
            valToShow = "No";
        }
        return (
            <div className="container-fluid">
                <span>{valToShow}</span>
            </div>
        );
    };

    onRefresh = (isRefresh: boolean) => {
        if (isRefresh) {
            //setTimeout( () => {
            this.updateGridDataSource();
            //}, 15000);
        }
    };

    InvoiceAmountCell = (cellInfo: any) => {
        return (
            <>
                <InvoiceAmountCell data={cellInfo} onRefresh={this.onRefresh} />
            </>
        );
    };
    formatToDDMMYYYY = (dateTimeString: string): string => {
        if (!dateTimeString) return "";
        const [datePart] = dateTimeString.split("T"); // Get "2023-03-09"
        const [year, month, day] = datePart.split("-"); // Split into [2023, 03, 09]
        return `${day}/${month}/${year}`; // Return "09/03/2023"
    };
    formatToHHMM = (dateTimeString: string): string => {
        if (!dateTimeString) return "";
        const [, timePart] = dateTimeString.split("T"); // Get time part: "00:00:00"
        if (!timePart) return "";
        const [hours, minutes] = timePart.split(":"); // Split into [00, 00, 00]
        return `${hours}:${minutes}`; // Return "00:00"
    };

    venueCellDisplayContent = (cellInfo: any) => {
        return (
            <div>
                <Link
                    onClick={(e: MouseEvent) => {
                        e.preventDefault();
                        this.showInfoVenue(cellInfo.data.clientBusinessEntityId, cellInfo.data.venueId);
                    }}
                    className="approval-query-column"
                    to="#"
                >
                    {cellInfo.data.venueName}
                </Link>
            </div>
        );
    };
    showInfoVenue = (clientId: string, venueId: string) => {
        this.setState({
            venuePopupVisible: true,
            clientId: clientId,
            venueId: venueId,
        });
    };
    hideInfoVenue = () => {
        this.setState({
            venuePopupVisible: false,
            clientId: "",
            venueId: "",
        });
    };
    renderProviderNet = (cellInfo: any) => {
        if (cellInfo.data.providerPayAmountLocal === null) return "";
        let providerNet = this.gridUtils.convertDecimalAsStringToCurrency(
            cellInfo.data.providerPayAmountLocal?.toString(),
            currencyTypeToSymbolMatrix[cellInfo.data.currency]
        );
        return (
            <div className="fa-file">
                <b>{providerNet}</b>
            </div>
        );
    };
    render() {
        return (
            <div>
                <h4 className="ml-3 font-weight-bold"></h4>
                {this.state.showProgressIndicator ? (
                    <div className="starter-template">
                        <LoadIndicator
                            id="simple-grid-indicator"
                            height={50}
                            width={50}
                            visible={this.state.showProgressIndicator}
                        />
                    </div>
                ) : (
                    <DataGrid
                        dataSource={this.state.gridDataSource}
                        showBorders={false}
                        showColumnLines={false}
                        hoverStateEnabled={true}
                        columnAutoWidth={true}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        columnResizingMode={"widget"}
                        className="entertainment-payment-grid"
                        onExporting={this.onExporting}
                    >
                        <SearchPanel visible={true} placeholder={"Search"} />
                        <Selection mode="single" />
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Paging defaultPageSize={10} />
                        <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20]} showInfo={true} />
                        {UserService.isUserInGroup(RoleGroupNames.EventUKSeniorManager) ? (
                            <Column
                                dataField="action"
                                caption="Edit"
                                cellComponent={paymentActionCell}
                                allowExporting={false}
                            />
                        ) : null}
                        <Column dataField="paymentId" caption="PAYMENT ID" />
                        <Column dataField="paymentCycleId" caption="PAYMENT CYCLE ID" />
                        <Column dataField="serviceId" caption="SERVICE ID" />
                        <Column dataField="serviceValue" caption="SERVICE" cellComponent={AllUserGridService} />
                        <Column dataField="subType" caption="SUB TYPE" />
                        <Column dataField="type" caption="TYPE" />
                        <Column dataField="entityId" caption="PROVIDER ID" />
                        <Column dataField="entity" caption="PROVIDER" />
                        <Column
                            dataField="subAmount"
                            caption="NET PAY AMOUNT"
                            calculateDisplayValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToCurrency(
                                    rowData.subAmount,
                                    currencyTypeToSymbolMatrix[rowData.currency]
                                );
                            }}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.subAmount);
                            }}
                        />
                        <Column
                            dataField="tax"
                            caption="VAT"
                            calculateDisplayValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToCurrency(
                                    rowData.tax,
                                    currencyTypeToSymbolMatrix[rowData.currency]
                                );
                            }}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.tax);
                            }}
                        />
                        <Column
                            dataField="amount"
                            caption="GROSS PAY AMOUNT"
                            cellRender={this.InvoiceAmountCell}
                            calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertDecimalAsStringToFloat(rowData.amount);
                            }}
                        />
                        <Column
                            dataField="fasterPay"
                            caption="FASTER PAY"
                            cellComponent={this.fasterPayCellDisplayContent}
                            dataType="boolean"
                        />
                        <Column
                            dataField="fasterPayId"
                            caption="FASTER PAY ID"
                            width={350}
                        />
                        <Column dataField="sortCode" caption="SORT CODE" />
                        <Column dataField="accountNumber" caption="ACCOUNT NUMBER" />
                        <Column dataField="reference" caption="REFERENCE" />
                        <Column dataField="status" caption="PAYMENT STATUS" />
                        <Column
                            dataField="fasterPayOriginalAmount"
                            caption="ORIGINAL FEE"
                            cellRender={this.calculatefasterPayOriginalAmount}
                        ></Column>
                        <Column
                            dataField="fasterPayFee"
                            caption="FASTER PAY FEE"
                            cellRender={this.calculatefasterPayFee}
                        />
                        <Column
                            dataField="fasterPayOriginalAmount"
                            name="fasterPayOriginalAmountTotal"
                            caption="PAY AMOUNTS (FP CALC)"
                            cellRender={this.calculatePayAmounts}
                            allowGrouping={false}
                            allowFiltering={false}
                            allowSearch={false}
                            allowSorting={false}
                        />
                        <Column dataField="id" caption="BILLABLE ITEM ID" />
                        <Column dataField="clientBusinessEntityId" caption="CLIENT ID" />
                        <Column dataField="client" caption="CLIENT" />
                        <Column dataField="venueName" caption="VENUE" cellRender={this.venueCellDisplayContent} />
                        <Column
                            dataField="dateFrom"
                            caption="DATE WORKED"
                            //cellRender={({ data }) => this.formatToDDMMYYYY(data.dateFrom)}
                        />
                        <Column dataField="quantity" caption="QUANTITY" />
                        <Column
                            dataField="billableStartTime"
                            caption="START TIME"
                            //cellRender={({ data }) => this.formatToDDMMYYYY(data.billableStartTime)}
                        />
                        <Column
                            dataField="billableFinishTime"
                            caption="FINISH TIME"
                            //cellRender={({ data }) => this.formatToDDMMYYYY(data.billableFinishTime)}
                        />
                        <Column
                            dataField="providerPayAmountLocal"
                            caption="PROVIDER NET"
                            dataType="number"
                            cellRender={this.renderProviderNet}
                        >
                            <Format type="currency" currency="GBP" precision={2}></Format>
                        </Column>
                        {/* cellRender={this.renderProviderNet}/> */}
                        <Column dataField="providerPayAmountTaxLocal" caption="PROVIDER VAT" dataType="number">
                            <Format type="currency" currency="GBP" precision={2}></Format>
                        </Column>
                        <Column dataField="providerPayAmountTotalLocal" caption="PROVIDER GROSS" dataType="number">
                            <Format type="currency" currency="GBP" precision={2}></Format>
                        </Column>
                        <FilterRow visible={true} applyFilter="auto" />
                    </DataGrid>
                )}
                <Popup
                    visible={this.state.venuePopupVisible}
                    onHiding={this.hideInfoVenue}
                    dragEnabled={false}
                    hideOnOutsideClick={true}
                    showTitle={true}
                    showCloseButton={true}
                    title="Client Information & Schedule"
                    resizeEnabled={true}
                >
                    <ScrollView width="100%" height="100%">
                        <ClientInformationMainContent
                            clientId={this.state.clientId}
                            venueId={this.state.venueId}
                            isShowByVenue={true}
                            serviceTypeId={this.props.serviceTypeId ? this.props.serviceTypeId : ""}
                        ></ClientInformationMainContent>
                    </ScrollView>
                </Popup>
            </div>
        );
    }
}
export default PaymentsGridProviderWithDetails;
